import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoaderComponent } from '@app/shared/components/page-loader/page-loader.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PageLoaderComponent],
  exports: [PageLoaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageLoaderModule {}
